(function() {
  var modal = document.getElementById('ch-bis-modal');
  var overlay = document.getElementById('ch-bis-overlay');
  var closeBtn = document.getElementById('ch-bis-close');
  var form = document.getElementById('ch-bis-form');
  var emailInput = document.getElementById('ch-bis-email');
  var submitBtn = document.getElementById('ch-bis-submit');
  var errorEl = document.getElementById('ch-bis-error');
  var successEl = document.getElementById('ch-bis-success');
  var productImg = document.getElementById('ch-bis-product-img');
  var productTitle = document.getElementById('ch-bis-product-title');
  var productInfo = document.getElementById('ch-bis-product-info');
  var modalTitle = document.getElementById('ch-bis-modal-title');
  var modalSubtitle = document.querySelector('.ch-bis-modal__subtitle');
  var manageEl = document.getElementById('ch-bis-manage');
  var manageListEl = document.getElementById('ch-bis-manage-list');

  var DEFAULT_TITLE = 'Notify me when available';
  var DEFAULT_SUBTITLE = "Enter your email and we'll let you know the moment this item is back in stock.";
  var CANCEL_METRIC_NAME = 'Cancelled Back In Stock Alert';
  var BIS_STORAGE_KEY = 'ch_bis_subscriptions';

  var currentVariantId = null;
  var currentProductId = null;

  /* ── Registro local de suscripciones (solo para UI: estado "Subscribed" y gestión) ── */
  function getBisSubscriptions() {
    try { return JSON.parse(localStorage.getItem(BIS_STORAGE_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveBisSubscriptions(list) {
    try { localStorage.setItem(BIS_STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isSubscribed(variantId) {
    var vid = String(variantId || '');
    return vid !== '' && getBisSubscriptions().some(function (s) { return s.variantId === vid; });
  }
  function addBisSubscription(sub) {
    var list = getBisSubscriptions().filter(function (s) { return s.variantId !== sub.variantId; });
    list.push(sub);
    saveBisSubscriptions(list);
  }
  function removeBisSubscription(variantId) {
    var vid = String(variantId);
    saveBisSubscriptions(getBisSubscriptions().filter(function (s) { return s.variantId !== vid; }));
  }
  function escBis(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ── Estado visual del botón "Notify me" / "Subscribed" en cualquier card del sitio ── */
  var BELL_ICON = '<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>';
  var ENVELOPE_ICON = '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>';

  function updateOosButtonVisual(btn, subscribed) {
    /* Bail out if already in this state — writing textContent/innerHTML unconditionally
       replaces child text nodes on every call, which re-triggers the global MutationObserver
       below and would otherwise spin in an infinite loop. */
    var targetState = subscribed ? 'subscribed' : 'unsubscribed';
    if (btn._chBisRenderedState === targetState) return;
    btn._chBisRenderedState = targetState;
    /* CTA de la card: texto corto y campana tambien en el estado "Notify me" */
    var isCard = btn.classList.contains('ch-card-notify');

    var textEl = btn.querySelector('.ch-shipping-eta__text');
    var iconEl = btn.querySelector('.ch-shipping-eta__icon');
    if (subscribed) {
      btn.classList.add('ch-shipping-eta--subscribed');
      btn.setAttribute('aria-label', 'Manage your stock alert for this product');
      if (textEl) textEl.textContent = 'Subscribed';
      if (iconEl) { iconEl.innerHTML = BELL_ICON; iconEl._chBisState = 'bell'; }
    } else {
      btn.classList.remove('ch-shipping-eta--subscribed');
      btn.setAttribute('aria-label', 'Notify me when available');
      if (textEl) textEl.textContent = isCard ? 'Notify me' : 'Notify me when available';
      if (iconEl) { iconEl.innerHTML = isCard ? BELL_ICON : ENVELOPE_ICON; iconEl._chBisState = isCard ? 'bell' : 'envelope'; }
    }
  }

  function applySubscribedState(scope) {
    var root = scope || document;
    root.querySelectorAll('.ch-shipping-eta--oos[data-bis-variant-id]').forEach(function (btn) {
      updateOosButtonVisual(btn, isSubscribed(btn.getAttribute('data-bis-variant-id')));
    });
  }

  /* ── Vista: suscribirse (comportamiento original) ── */
  function openModal(productId, variantId, title, image) {
    currentProductId = productId;
    currentVariantId = variantId;
    if (modalTitle) modalTitle.textContent = DEFAULT_TITLE;
    if (modalSubtitle) modalSubtitle.textContent = DEFAULT_SUBTITLE;
    if (productInfo) productInfo.style.display = '';
    if (productImg && image) { productImg.src = image; productImg.alt = title || ''; }
    if (productTitle && title) productTitle.textContent = title;
    if (manageEl) manageEl.style.display = 'none';
    form.style.display = '';
    successEl.style.display = 'none';
    errorEl.style.display = 'none';
    emailInput.value = '';
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    setTimeout(function() { emailInput.focus(); }, 100);
  }

  /* ── Vista: gestionar suscripciones existentes ── */
  function renderManageList() {
    if (!manageListEl) return;
    var subs = getBisSubscriptions();
    if (!subs.length) {
      manageListEl.innerHTML = '<li class="ch-bis-manage-empty">You have no active stock alerts.</li>';
      return;
    }
    manageListEl.innerHTML = subs.map(function (sub) {
      return '<li class="ch-bis-manage-item">' +
        '<img class="ch-bis-manage-item__img" src="' + escBis(sub.image) + '" alt="" width="48" height="48">' +
        '<span class="ch-bis-manage-item__title">' + escBis(sub.title) + '</span>' +
        '<button type="button" class="ch-bis-manage-item__cancel" data-variant-id="' + escBis(sub.variantId) + '">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
          'Cancel</button>' +
      '</li>';
    }).join('');
  }

  function openManageModal() {
    if (modalTitle) modalTitle.textContent = 'Your stock alerts';
    if (modalSubtitle) modalSubtitle.textContent = 'Manage the products you asked to be notified about.';
    if (productInfo) productInfo.style.display = 'none';
    form.style.display = 'none';
    successEl.style.display = 'none';
    errorEl.style.display = 'none';
    if (manageEl) manageEl.style.display = 'block';
    renderManageList();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  if (manageListEl) {
    manageListEl.addEventListener('click', function (e) {
      var cancelBtn = e.target.closest('.ch-bis-manage-item__cancel');
      if (!cancelBtn) return;
      var vid = cancelBtn.getAttribute('data-variant-id');
      var sub = getBisSubscriptions().filter(function (s) { return s.variantId === vid; })[0];
      if (!sub) return;
      cancelBtn.disabled = true;
      cancelBtn.textContent = 'Cancelling…';

      var klaviyoKey = window.chKlaviyoPublicKey || '';
      var finish = function () {
        removeBisSubscription(vid);
        applySubscribedState(document);
        renderManageList();
      };
      if (!klaviyoKey) { finish(); return; }

      fetch('https://a.klaviyo.com/client/events/?company_id=' + klaviyoKey, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-07-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: { variant_id: sub.variantId, product_id: sub.productId, title: sub.title },
              metric: { data: { type: 'metric', attributes: { name: CANCEL_METRIC_NAME } } },
              profile: { data: { type: 'profile', attributes: { email: sub.email } } }
            }
          }
        })
      }).catch(function () {}).finally(finish);
    });
  }

  function closeModal() {
    var isMobile = window.innerWidth <= 749;
    if (isMobile) {
      modal.classList.add('is-closing');
      setTimeout(function() {
        modal.style.display = 'none';
        modal.classList.remove('is-closing');
        document.body.style.overflow = '';
      }, 300);
    } else {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  if (overlay) overlay.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!email) return;
      submitBtn.disabled = true;
      errorEl.style.display = 'none';

      var klaviyoKey = window.chKlaviyoPublicKey || '';
      if (!klaviyoKey) { errorEl.textContent = 'Configuration error.'; errorEl.style.display = ''; submitBtn.disabled = false; return; }

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + currentVariantId
              }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + klaviyoKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-06-15'
        },
        body: JSON.stringify(payload)
      })
      .then(function(r) {
        if (r.ok || r.status === 200) {
          form.style.display = 'none';
          successEl.style.display = 'flex';
          addBisSubscription({
            variantId: String(currentVariantId),
            productId: String(currentProductId),
            title: productTitle ? productTitle.textContent : '',
            image: productImg ? productImg.src : '',
            email: email,
            subscribedAt: Date.now()
          });
          applySubscribedState(document);
        } else {
          throw new Error('API error');
        }
      })
      .catch(function() {
        errorEl.textContent = 'Something went wrong. Please try again.';
        errorEl.style.display = '';
        submitBtn.disabled = false;
      });
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var bisBtn = e.target.closest('.ch-shipping-eta--oos');
    if (!bisBtn) return;
    e.preventDefault();
    if (isSubscribed(bisBtn.dataset.bisVariantId)) {
      openManageModal();
      return;
    }
    openModal(
      bisBtn.dataset.bisProductId,
      bisBtn.dataset.bisVariantId,
      bisBtn.dataset.bisProductTitle,
      bisBtn.dataset.bisProductImage
    );
  });

  applySubscribedState(document);

  /* Cubre botones "Notify me" que aparecen después vía AJAX en cualquier
     parte del sitio: recomendaciones de producto, mega menú, quick-add,
     filtros de colección, section rendering de la wishlist, etc. */
  if (window.MutationObserver) {
    var bisObserver = new MutationObserver(function (mutations) {
      var hasNew = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (hasNew) applySubscribedState(document);
    });
    bisObserver.observe(document.body, { childList: true, subtree: true });
  }

  window.chOpenBisModal = openModal;
  window.chBisApplySubscribedState = applySubscribedState;
})();
